import React, { Component } from 'react';
import { Modal } from 'antd';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
  }

  handleClose = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Modal
          title="应用错误"
          visible={true}
          onCancel={this.handleClose}
          footer={null}
          width={800}
        >
          <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
            <h3>错误详情:</h3>
            <pre>{this.state.error && this.state.error.toString()}</pre>
            <h3>调用栈:</h3>
            <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
          </div>
        </Modal>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;